export default __webpack_public_path__ + "static/media/img (3).3596d54f.jpg";